import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import Herba from './pages/work/Herba';
import CultureAmp from './pages/work/CultureAmp';
import Disco from './pages/work/Disco';
import Flok from './pages/work/Flok';
import WhoSay from './pages/work/WhoSay';
import ScrollToTop from './components/ScrollToTop';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/work/herba" element={<Herba />} />
        <Route path="/work/culture-amp" element={<CultureAmp />} />
        <Route path="/work/disco" element={<Disco />} />
        <Route path="/work/flok" element={<Flok />} />
        <Route path="/work/whosay" element={<WhoSay />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
